import { Injectable } from '@angular/core';
import { FormGenerator } from './form-generator.component';

@Injectable()
export class FormGeneratorService {

  private static formId = 1;
  private static fieldId = 1;

  public createForm(form: FormGenerator.Form): FormGenerator.Form {
    // add ids to keep track of the fields
    form.fields.forEach(f => {
      f.id = this.generateFieldId();
      if (f.fields) {
        f.fields.forEach(sf => {
          sf.id = this.generateFieldId();
        });
      }
    });

    form.id = this.generateFormId(); // keep track of forms

    return form;
  }

  /**
   * Generate a form id to identify a form-generator
   */
  public generateFormId(): number {
    return FormGeneratorService.formId++;
  }

  /**
   * Generate a field id to identify a form-generator's field
   */
  public generateFieldId(): number {
    return FormGeneratorService.fieldId++;
  }
}
